module.exports = __webpack_public_path__ + "static/DGHAL-29138fa8ef848d1fe9e1cd1cfe132e75.png";